var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNodeIconWhite = function SvgNodeIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E6F1F2",
    strokeWidth: 1.5,
    clipPath: "url(#node-icon-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 6 2.293-2.293a1 1 0 0 1 1.414 0L15 6l-3 3zM9 18l3-3 3 3-2.293 2.293a1 1 0 0 1-1.414 0zM3.707 12.707a1 1 0 0 1 0-1.414L6 9l3 3-3 3zM15 12l3-3 2.293 2.293a1 1 0 0 1 0 1.414L18 15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "node-icon-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgNodeIconWhite as ReactComponent };
export default __webpack_public_path__ + "8ed4a55e58d5d1ff2244116719e0613b.svg";